export default "__VITE_ASSET__DozDSqiV__"